export default __webpack_public_path__ + "008753b8662124641c493f368ab9c91e.png";